/**
 * `/` (`111-frontend-architecture.md` §7).
 *
 * Redirects to `rn.lastPage` if that page still exists, otherwise the first root page,
 * otherwise the one-screen welcome.
 */
import { Navigate } from 'react-router';
import { Skeleton } from '@/components/ui/skeleton';
import { Welcome } from '@/features/notebook/Welcome';
import { childrenOf } from '@/features/notebook/treeModel';
import { useTree } from '@/features/notebook/usePageMutations';

export function RootRedirect() {
  const tree = useTree();

  if (tree.isPending) {
    return (
      <div className="mx-auto max-w-[78ch] space-y-3 p-6">
        <Skeleton className="h-7 w-1/3" />
        <Skeleton className="h-3 w-2/3" />
      </div>
    );
  }

  const pages = tree.data?.pages ?? [];

  const last = localStorage.getItem('rn.lastPage');
  if (last !== null && pages.some((page) => page.id === last)) {
    return <Navigate to={`/p/${last}`} replace />;
  }

  const first = childrenOf(pages).get(null)?.[0];
  if (first !== undefined) return <Navigate to={`/p/${first.id}`} replace />;

  return <Welcome />;
}
